import React from 'react';
import './Popular.css';
import data_product from '../Assets/all_product';
import Item from '../Item/Item';

const Popular = () => {
  return (
    <section className="popular">
      <div className="container">

        <h1>POPULAR IN WOMEN</h1>
        <hr />

        <div className="popular-item">
          {data_product
            .filter((item) => item.category === "women")
            .slice(0, 4)
            .map((item) => (
              <Item
                key={item.id}
                id={item.id}
                name={item.name}
                image={item.image}
                new_price={item.new_price}
                old_price={item.old_price}
              />
            ))}
        </div>

      </div>
    </section>
  );
};

export default Popular;